import { render, staticRenderFns } from "./MiraStackedTrendCard.vue?vue&type=template&id=040e8b6e&scoped=true&"
import script from "./MiraStackedTrendCard.vue?vue&type=script&lang=ts&"
export * from "./MiraStackedTrendCard.vue?vue&type=script&lang=ts&"
import style0 from "./MiraStackedTrendCard.vue?vue&type=style&index=0&id=040e8b6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040e8b6e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCard } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VBtnToggle,VCard,VSpacer})
